export default {
  PROD: "production",
  STAGE: "stage",
};
